import { useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import { findIndex, values } from 'lodash'
import Step4SelectUserFunction from '@/pages/account/twc/_components/JoinOrganizationForTwcPage/Step4SelectUserFunction'

export const Route = createFileRoute('/app/account/twc/join/$orgType/$orgId/$ufcId')({
  component: RouteComponent,
})

function RouteComponent() {
  const orgTypes = useSelector((state: any) => state.app_meta.data.organizationTypes)

  const validateOrgTypeMachineName = useCallback(
    (otm: string) => {
      otm = otm.toLowerCase()
      let orgTypesArr = values(orgTypes)
      let idx = findIndex(orgTypesArr, ['machine_name', otm])
      return idx !== -1
    },
    [orgTypes],
  )

  return <Step4SelectUserFunction validateOrgTypeMachineNameFn={validateOrgTypeMachineName} />
}
